import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { moss } from './mossdata.js';
import { diffi } from './diff.js';
import { names } from './names.js';
import { bryoatt } from './bryoatt2.js';
import { mossworld } from './mossworld.js';
import { attrib } from './attrib.js';
import Button from '@mui/material/Button';

import 'swiper/css';
import "swiper/css/navigation";
import { Navigation } from "swiper";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


const flexstyle = {display:'flex'};  
const blockstyle = {display:'block'}; 

  function KeyTitle({line}) {
    return (
    <h3 className='header'>
      {line < 5 && 'Bryophytes'}
      {line > 4 && line < 24 && 'Thallose liverworts'}
      {line > 23 && line < 30 && 'Leafy liverworts'}
      {line > 29 && line < 45 && 'Liverworts with 2 unequal lobes to each leaf'}
      {line > 44 && line < 65 && 'Liverworts with symmetrical 2, 3 or 4-cleft leaves'}
      {line > 64 && line < 78 && 'Liverworts with unlobed, rounded leaves'}
      {line > 77 && line < 88 && 'Acrocarps'}
      {line > 87 && line < 96 && 'Acrocarps with plates of green tissue on the nerve'}
      {line > 95 && line < 104 && 'Acrocarps with shoots like miniature ferns'}
      {line > 103 && line < 126 && 'Acrocarps with leaves ending in a white hair point'}
      {line > 125 && line < 156 && 'Acrocarps with leaves tapering to a long, fine point'}
      {line > 155 && line < 172 && 'Acrocarps with large leaves forming large patches'}
      {line > 171 && line < 181 && 'Other acrocarps growing on tarmac or concrete paths'}
      {line > 180 && line < 196 && 'Other acrocarps growing on walls'}
      {line > 195 && line < 225 && 'Other acrocarps growing on rocks and drystone walls'}
      {line > 224 && line < 267 && 'Other acrocarps growing on soil'}
      {line > 266 && line < 285 && 'Other acrocarps growing on wood'}
      {line > 284 && line < 288 && 'Pleurocarps'}
      {line > 287 && line < 297 && 'Pleurocarps with shoots strongly flattened'}
      {line > 296 && line < 370 && 'Pleurocarps with leaves strongly curved'}
    </h3>
    )
  }

  function SpeciesTitle({species}) {
    return (
      // <h3 className='species'><a href={'https://commons.wikimedia.org/w/index.php?search='+species+'&title=Special:MediaSearch&type=image'} target="_blank">
      <h3 className='species'><a href={'https://www.britishbryologicalsociety.org.uk/learning/species-finder/'+species.split(' ').join('-')} target="_blank">
        {species}
        </a>
    </h3>
    )
  }

  function SpeciesInfo({species}) {
  const mossname = names.find(x => x.latin === species)?.english;
  const mwdesc = mossworld.find(x => x.NAME === species)?.DESC;
  const diffinotes = diffi.find(x => x.NAME === species)?.NOTES;
  const bryofilter = bryoatt.filter(x => x.Name_new === species);
    
  const bryolist = bryofilter.map(x => <>
    <li>{'Order: '}{x.Ord}</li>
    <li>{'Length: '}{x.Len}{'mm'}</li>
    <li>{(x.Per === 'A') ? 'Annual' : 'Perennial'}</li>
    <li>{(x.Sex === 'M') ? 'Monoecious' : 'Dioecious'}</li>
    <li>{'Light level: '}{x.L}</li>
    <li>{'Moisture: '}{x.F}</li>
    <li>{'pH: '}{x.R}</li>
    <li>{'Nitrogen: '}{x.N}</li>
    <li>{x.Lvs === 'F' && 'Deciduous leaves'}
      {x.Bra === 'F' && 'Deciduous branches'}
      {x.Bul === 'F' && 'Bulbils present'}
      {x.Gem === 'F' && 'Gemmae present'}
      {x.Tub === 'F' && 'Tubers present'}</li>
  </>
  );

    return (
    <div className="text" style={blockstyle}>
      { mossname && <p id="speciestext"><i>{mossname}</i></p>}
      { mwdesc && <p id="speciestext">{mwdesc}</p> }
      { diffinotes && <p id="speciestext">{diffinotes}</p> }
      { bryolist && <ul className="bryolist"  id="speciestext">{bryolist}</ul>}
    </div>
    )
  }

  export default function MossKey() {

    
    const [lineNo, setLineNo] = useState(1);
    const [history, setHistory] = useState([]);
    const [showHistory, setshowHistory] = useState(false);
    const [showGallery, setshowGallery] = useState(false);

    function handleHistoryClick() {
      setshowHistory(!showHistory);
    }

    function handleGalleryClick() {
      setshowGallery(!showGallery);
    }

    function handleBackClick() {
      setHistory([...history.slice(0, -1)]);
      setLineNo(history[history.length-1].num);      
    }

    let isSpecies = (typeof lineNo === 'string');
    let historyArray =[];   
    
    

    const buttonfilter = moss.filter(f => f.line === lineNo);
    const buttons = buttonfilter.map((line, index) => 
    <div id="choice" key={line.goto} style={{backgroundImage: 'url(/img/keypic/' + lineNo + String.fromCharCode(97 + index) + '.jpg)'}} onClick={() => buttonClick(line.goto,line.line,line.text,history)}>
      <p id="choicetext">
      {line.line}{' '}{line.text}
      </p>
      </div>
    );

    function buttonClick(goto,line,text,history) {
      setHistory([...history, { num:line, text:text }]);
      setLineNo(goto);  
      setshowHistory(false);      
    }

    const timeline = history.map((item, index) => 
    <button key={item.num} id = {index} variant="contained" onClick={e => historyClick(item.num,history,e.target.id)}>{item.text}</button>);

    function historyClick(goto,history,id) {        
      let idplus = parseInt(id);
      historyArray = [...history.slice(0, idplus)];
      setHistory(historyArray);
      setLineNo(goto);  
      setshowHistory(false);  
    }

    const imgURL = '/img/keypic/' + lineNo + '.jpg';

    const images = <img
    src={imgURL.split(' ').join('_')}
    alt={''}
  />;
  
//   const attribfilter = attrib.filter(f => f.name === lineNo);
//   const swiper =  attribfilter.map((name) =>
//   <Swiper navigation={true} modules={[Navigation]} className="mySwiper" loop={true}>    
//   <SwiperSlide><img src={('/img/keypic/' + name.name + '.jpg').split(' ').join('_')} alt={''} /><p id="caption"><a href={name.a1} target="_blank">Photo taken by {name.t1}</a></p></SwiperSlide>
//   <SwiperSlide><img src={('/img/keypic/' + name.name + '3.jpg').split(' ').join('_')} alt={''} /><p id="caption"><a href={name.a2} target="_blank">Photo taken by {name.t2}</a></p></SwiperSlide>
//   <SwiperSlide><img src={('/img/keypic/' + name.name + '5.jpg').split(' ').join('_')} alt={''} /><p id="caption"><a href={name.a3} target="_blank">Photo taken by {name.t3}</a></p></SwiperSlide>
// </Swiper>
// );

const swiper =  <Swiper navigation={true} modules={[Navigation]} className="mySwiper" loop={true}>
<SwiperSlide><img src={('/img/keypic/' + lineNo + '.jpg').split(' ').join('_')} alt={''} /></SwiperSlide>
<SwiperSlide><img src={('/img/keypic/' + lineNo + '3.jpg').split(' ').join('_')} alt={''} /></SwiperSlide>
<SwiperSlide><img src={('/img/keypic/' + lineNo + '5.jpg').split(' ').join('_')} alt={''} /></SwiperSlide>
</Swiper>;

  return (
      
      <div className="page">
      {isSpecies && <div className="speciesback">{images}</div>}

      <div className="title">
      {isSpecies ? <SpeciesTitle species={lineNo}/> : <KeyTitle line={lineNo}/>}
      </div>

      <div className="history">
      {history.length > 0 && <Button variant="contained" onClick={handleHistoryClick}>{showHistory ? 'Hide' : 'History'}</Button>}      
      </div>
     
      {showHistory &&  <div className="timeline">{timeline}</div>}    
      
      <div className="content">
      {isSpecies ? <SpeciesInfo species={lineNo}/> :  buttons}
      </div>
         
      {isSpecies && <div className="gallery"><Button variant="contained" onClick={handleGalleryClick}>{showGallery ? 'Hide' : 'Gallery'}</Button></div> } 

      {showGallery &&  <div className="swiperholder">{swiper}</div>} 

      <div className="back">
      {history.length > 0 && <Button variant="contained" onClick={handleBackClick}>Back</Button>}
      </div>  
      
    </div>

  )
}
